import { createAction } from 'redux-actions'
import { SET_LOADING_STATE, SET_ERROR_MESSAGE } from '../constants/commonConstant'

export let setLoadingState = createAction(SET_LOADING_STATE)
export let setErrorMessage = createAction(SET_ERROR_MESSAGE)